import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'm-words',
  template: `
    <code [innerHTML]="mText | computeSpaces"></code>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: true,
  host: {
    class: 'm-words'
  }
})
export class MWordsComponent {
  @Input() mText: string = '';
}
